import { Course } from '../types';

// Course metadata with visibility and feature flags
export interface CourseMetadata {
  id: string;
  title: string;
  icon: string;
  subject: string;
  testDate?: string;
  hasMap: boolean;      // Whether the course has a map feature
  hidden: boolean;      // Admin-controlled visibility
}

// Course registry - add new courses here
export const AVAILABLE_COURSES: { id: string; loader: () => Promise<Course> }[] = [
  {
    id: 'eu-geographie',
    loader: async () => {
      const { euGeographieCourse } = await import('../data/eu-geographie/course');
      return euGeographieCourse;
    },
  },
  {
    id: 'english-test3',
    loader: async () => {
      const { englishTest3Course } = await import('../data/english-test3/course');
      return englishTest3Course;
    },
  },
  {
    id: 'deutsch-schularbeit',
    loader: async () => {
      const { deutschSchularbeitCourse } = await import('../data/deutsch-schularbeit/course');
      return deutschSchularbeitCourse;
    },
  },
  {
    id: 'mathe-schularbeit',
    loader: async () => {
      const { matheSchularbeitCourse } = await import('../data/mathe-schularbeit/course');
      return matheSchularbeitCourse;
    },
  },
  {
    id: 'spanisch-schularbeit',
    loader: async () => {
      const { spanischSchularbeitCourse } = await import('../data/spanisch-schularbeit/course');
      return spanischSchularbeitCourse;
    },
  },
];

// Course metadata (edit hidden: true/false to show/hide courses)
const COURSE_METADATA: CourseMetadata[] = [
  {
    id: 'eu-geographie',
    title: 'EU Geographie',
    icon: '🇪🇺',
    subject: 'GW',
    hasMap: true,
    hidden: true,  // Currently hidden - test is over
  },
  {
    id: 'english-test3',
    title: 'English – 3rd Test',
    icon: '🇬🇧',
    subject: 'Englisch',
    testDate: '2026-03-12',
    hasMap: false,
    hidden: false,
  },
  {
    id: 'deutsch-schularbeit',
    title: 'Deutsch Schularbeit',
    icon: '📝',
    subject: 'Deutsch',
    hasMap: false,
    hidden: false,
  },
  {
    id: 'mathe-schularbeit',
    title: 'Mathe Schularbeit',
    icon: '📐',
    subject: 'Mathematik',
    testDate: '2026-03-26',
    hasMap: false,
    hidden: false,
  },
  {
    id: 'spanisch-schularbeit',
    title: 'Spanisch Schularbeit',
    icon: '🇪🇸',
    subject: 'Spanisch',
    testDate: '2026-03-27',
    hasMap: false,
    hidden: false,
  },
];

// Get course by ID
export async function getCourse(courseId: string): Promise<Course | null> {
  const courseEntry = AVAILABLE_COURSES.find(c => c.id === courseId);
  if (!courseEntry) return null;
  return courseEntry.loader();
}

// Get course metadata by ID
export function getCourseMetadata(courseId: string): CourseMetadata | undefined {
  return COURSE_METADATA.find(c => c.id === courseId);
}

// Get all course metadata
// includeHidden: true = show all courses (for admins)
// includeHidden: false = only show visible courses (for students)
export function getCourseList(includeHidden = false): CourseMetadata[] {
  if (includeHidden) {
    return COURSE_METADATA;
  }
  return COURSE_METADATA.filter(c => !c.hidden);
}
